import { render, staticRenderFns } from "./AddOrUpdateDepartmentModal.vue?vue&type=template&id=0f5e9bc6"
import script from "./AddOrUpdateDepartmentModal.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateDepartmentModal.vue?vue&type=style&index=0&id=0f5e9bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports